import React from 'react';
import {useTranslation} from 'react-i18next';


function Footer(props) {
    const {t} = useTranslation();
    return (
        <footer>
            {t('Footer.title')}
        </footer>
    );
}

export default Footer;
